import React from "react";

class Tile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        let classes = "";
        let id = "";
        let tile = "";
        
        if (this.props.tile === "empty") {
            classes = "empty";
        // } else if (this.props.tile === "flower1" | this.props.tile === "flower2" | this.props.tile === "flower3" | this.props.tile === "flower4") {
        //     classes = "tile tile-" + this.props.graphics + " " + this.props.tile + " " + this.props.specialPosition;
        //     id = this.props.specialPosition;
        //     tile = "flower";
        // } else if (this.props.tile === "season1" | this.props.tile === "season2" | this.props.tile === "season3" | this.props.tile === "season4") {
        //     classes = "tile tile-" + this.props.graphics + " " + this.props.tile + " " + this.props.specialPosition;
        //     id = this.props.specialPosition;
        //     tile = "season";
        } else {
            classes = "tile tile-" + this.props.graphics + " " + this.props.tile + " " + this.props.specialPosition;
            id = this.props.specialPosition;
            tile = this.props.tile;
        }

        return (
            <div id={id} className={classes} data-layer="layer5" data-row={this.props.row} data-index="0" data-tile={tile} onClick={this.props.clicker}>

            </div>
        );
    }
}

export default Tile;